import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.scss']
})
export class LibraryComponent implements OnInit {
  imgUrl=[
    '/assets/img/library/1.jpeg'
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
